import { IonItem, IonLabel } from '@ionic/react';
import React from 'react';
import { useContextTranslation } from 'ui/translation';

import ButtonSelector from '../../../ui/elements/ButtonSelector';

const AVAILABLE_VALUES: number[] = [1, 2, 3, 4, 5];

const VoucherAmountSelector: React.FC<{
  expanded: boolean;
  shouldDisplaySelectedValue: boolean;
  selectedNumber?: number;
  selectedValue?: string;
  onSelect: (selected: number) => void;
  expandSection: () => void;
}> = ({
  expanded,
  shouldDisplaySelectedValue,
  selectedNumber,
  onSelect,
  expandSection,
  selectedValue,
}) => {
  const t = useContextTranslation('page.voucher');

  const getVoucherLabel = React.useCallback(
    number => {
      if (selectedValue) {
        return t('voucher_number_with_value_label', {
          count: number,
          value: selectedValue,
        });
      }
      return t('voucher_number_label', {
        count: number,
      });
    },
    [selectedValue, t],
  );

  return (
    <section className={`button-selector ${expanded ? 'expanded' : ''}`}>
      <ButtonSelector
        className={`expand-button${
          shouldDisplaySelectedValue ? ' selected' : ''
        }`}
        onClick={expandSection}
        expandable
      >
        <div className="text-container">
          {selectedNumber
            ? getVoucherLabel(selectedNumber)
            : t('voucher_number_select')}
        </div>
      </ButtonSelector>
      <div className="selectable-container">
        {AVAILABLE_VALUES.map(value => (
          <IonItem
            className="voucher-amount-item"
            color={selectedNumber === value ? 'primary' : 'light'}
            key={value}
            onClick={() => onSelect(value)}
            lines="none"
          >
            <IonLabel color={selectedNumber === value ? 'light' : 'primary'}>
              {getVoucherLabel(value)}
            </IonLabel>
          </IonItem>
        ))}
      </div>
    </section>
  );
};

export default VoucherAmountSelector;
